import { useMutation } from '@tanstack/react-query';

import type { SetupPendingWooManualConnection } from '@/components/setup/experience/types';
import { useManualConnectWoocommerce } from '@/lib/api/integrations';

interface AttachPlatformIntegrationInput {
  storeId: string;
  connection: SetupPendingWooManualConnection;
}

/** Attach a verified platform connection to an existing store (products step). */
export function useSetupAttachPlatformIntegration() {
  const manualConnectWoo = useManualConnectWoocommerce();

  return useMutation({
    mutationFn: async ({ storeId, connection }: AttachPlatformIntegrationInput): Promise<void> => {
      await manualConnectWoo.mutateAsync({
        storeId,
        url: connection.url,
        consumerKey: connection.consumerKey,
        consumerSecret: connection.consumerSecret,
      });
    },
  });
}
